module.exports = __webpack_public_path__ + "/bundle/asset/U2_06-0cd745742840ab79f1b3665105a90efa.gif";